<div class="bg-th-blue mt-0 container-fluid py-2 position-sticky top-0 index-3">
    <div class=" d-flex justify-content-between justify-content-md-end align-content-center">
        <i class="fa fa-arrow-left text-white my-auto pointer" (click)="goBack()" *ngIf="!isDesktop"></i>

        <a class="text-white f18 my-auto dirI d-flex align-items-center">داشبورد تبلیغات <i class="fa fa-question-circle my-auto me-2 fa-2x pointer" (click)="guid(39)"></i></a>


    </div>
</div>
<div class="col-12 d-flex justify-content-around mt-1 flex-wrap dirI">

    <div class="col-9 col-md-3 dirI px-2">
        <label class="mb-2"> از تاریخ</label>
        <form [formGroup]="dataFrom">
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                <input id="startDate" type="text" formControlName="date" class="form-control shadow text-end" readonly />
            </ng-persian-datepicker>
        </form>
    </div>
    <div class="col-9 col-md-3 dirI px-2">
        <label class="mb-2"> تا تاریخ</label>
        <form [formGroup]="dataTo">
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                <input type="text" formControlName="date" class="form-control shadow text-end" readonly />
            </ng-persian-datepicker>
        </form>
    </div>
    <div class="col-9 col-md-3 dirI px-2">
        <label class="mb-2"> حوزه خدمت</label>

        <select class="form-select" id="domainDashbord">
            <option value="-1">انتخاب کنید</option>
            <option *ngFor="let item of domain" value="{{item.iMobileDomain}}">{{item.strComment}}</option>
        </select>
    </div>




    <div class=" col-9 col-md-3 dirI px-2">
        <label class="mb-2">گروه خودرو</label>

        <select id="carGroup" class="form-select">
        <option value="-1">نمایش همه</option>
        <option *ngFor="let item of groupCar" value="{{item.tiMobileGroup}}">{{item.strComment}}</option>
    </select>

    </div>
    <div class=" col-9 col-md-3 dirI px-2">
        <label class="mb-2">نوع خودرو</label>
        <select class="form-select" id="carType">
            <option value="-1" selected>انتخاب کنید</option>
            <option *ngFor="let item of carType" value="{{item.tiGPSType}}">
                {{item.strComment}}
            </option>
        </select>

    </div>
    <div class=" col-9 col-md-3 dirI px-2">
        <label class="mb-2">تبلیغات </label>
        <select class="form-select" id="taxiADS">
            <option value="-1" selected>انتخاب کنید</option>
            <option *ngFor="let item of listTaxiAdds" value="{{item.iTaxiADS}}">
                {{item.strSubject}}
            </option>
        </select>

    </div>

    <div class="col-9 col-md-2 dirI d-flex align-items-end justify-content-center mt-2 mt-sm-0">
        <button class="btn btn-primary" (click)="search()">به روز رسانی <i class="fa fa-search"></i></button>
    </div>

</div>

<div class="d-flex justify-content-around flex-wrap mt-4">
    


    <div id="chart1" class=" col-11  mb-5 justify-content-around d-flex row chart1 rounded shadow">
        <div class="col-12">


            <p class="text-center f18">آمار مخاطبین به تفکیک تبلیغ  </p>
            <canvas id="myChart2" style="max-height: 350px !important;"></canvas>
            

        </div>

    </div>




    <div id="chart15" class="col-md-11 col-12 justify-content-around d-flex row chart2 mb-5  rounded shadow mb-3">
        <div class="dirI">

            <p class="text-center f18 dirI">آمار تبلیغات پخش شده به تفکیک گروه خودرویی </p>
            <canvas id="myChart16" style="max-height: 350px !important;"></canvas>

        </div>

    </div>

    <div id="chart17" class="col-md-11 col-12 justify-content-around d-flex row chart2 mb-5  rounded shadow mb-3">
        <div class="dirI">

            <p class="text-center f18 dirI">	آمار تبلیغات پخش شده به تفکیک حوزه خدمت  </p>
            <canvas id="myChart18" style="max-height: 350px !important;"></canvas>

        </div>

    </div>
  

</div>


<div class="d-flex justify-content-center bg-gray flex-wrap">
    <div class="col-12 mt-3">
        <h3 class="text-center ">نقشه  پراکندگی محل پخش تبلیغات </h3>

    </div>
    <div class=" col-md-8 col-10 mb-5 border rounded-3 border-3 border-success mt-2">

        <div id="map1" class="fixed-mapCluster">
            <div class="position-absolute" id="map_tooltip" data-bs-html="true">
            </div>
        </div>
    </div>
</div>






<!-- Modal -->
<div class="modal fade dirI" id="carModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel" *ngIf="modalData">{{modalData.strFullName}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <p *ngIf="modalData">حوزه خدمت : {{modalData.strMobileDomain_strComment }}</p>
                <p *ngIf="modalData">پلاک : {{modalData.strVehicleNo }}</p>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">بستن</button>

            </div>
        </div>
    </div>
</div>
<!--Car Status Modal-->
<div class="modal fade dirI" id="CarStatusModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel"></h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body" style="max-height:60vh;overflow: auto;">
                <div class="table-responsive dirI rounded-3 border border-2 my-2">
                    <table class="table table-striped " id="car-status-exel">
                        <thead>
                            <!-- [ngClass]="showLocation  ? 'index-1' : ''" -->
                            <tr class="">
                                <th>#</th>

                                <th>نام و نام خانوادگی </th>
                                <th>شماره موبایل راننده </th>
                                <th>پلاک </th>
                                <th>حوزه خدمت </th>
                                <th>گروه </th>
                                <th>نوع </th>
                                <th>سال ساخت</th>
                                <th class="d-none">UnitID </th>
                                <th class="d-none">کیلومتر فعلی </th>


                            </tr>
                        </thead>
                        <tbody>
                            <tr class="" *ngFor="let item of carStatusData;let i=index">
                                <td>{{i+1|faNum}}</td>
                                <td>{{item.strFullName}}</td>
                                <td>{{item.strCellNo}}</td>
                                <td>{{item.strVehicleNo}}</td>
                                <td>{{item.strMobileDomain_strComment}}</td>
                                <td>{{item.strMobileGroup_strComment}}</td>
                                <td>{{item.strMobileType_strComment}}</td>
                                <td>{{item.iYearConstruction}}</td>
                                <td class="d-none">{{item.strUnitID }}</td>
                                <td class="d-none">{{item.fLastKM }}</td>



                            </tr>

                        </tbody>
                    </table>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="exportexcel('car-status-exel')">خروجی اکسل</button>

            </div>
        </div>
    </div>
</div>

<div class="modal fade dirI" id="carCluster" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content" *ngIf="clusterModal">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{clusterModal.strFullName}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body d-flex justify-content-around flex-wrap">
                <div class="col-5" *ngIf="clusterModal.strDate">
                    <p class="text-secondary dirI"> <span class="bold">آخرین زمان موقعیت</span> : {{clusterModal.strDate}}-{{clusterModal.strTime}}
                    </p>
                </div>
                <div class="col-5" *ngIf="clusterModal.strMobile">
                    <p class="text-secondary"> <span class="bold">موبایل</span> : {{clusterModal.strMobile}}</p>
                </div>
                <div class="col-5" *ngIf="clusterModal.strMobileType_strComment">
                    <p class="text-secondary"> <span class="bold">گروه خودرو</span> : {{clusterModal.strMobileType_strComment}}
                    </p>
                </div>
                <div class="col-5" *ngIf="clusterModal.strVehicleNo">
                    <p class="text-secondary"><span class="bold">پلاک</span> : {{clusterModal.strVehicleNo}}</p>
                </div>
                <div class="col-5 " *ngIf="clusterModal.strJournalType_strComment">
                    <p class="text-secondary"><span class="bold">تخلف</span> : {{clusterModal.strJournalType_strComment}}</p>
                </div>
                <div class="col-5" *ngIf="clusterModal.tiMaxSpeed">
                    <p class="text-secondary"><span class="bold">حداکثر سرعت مجاز</span> : {{clusterModal.tiMaxSpeed}}</p>
                </div>
                <div class="col-5" *ngIf="clusterModal.strComment">
                    <p class="text-secondary"><span class="bold">توضیحات</span> : {{clusterModal.strComment}}</p>
                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">بستن</button>

            </div>
        </div>
    </div>
</div>